// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

/**
 * Added v7 — see `ChannelModifier.schema_version`.
 *
 * A tri-state boolean for channel-modifier fields that need "unset" as well as
 * true and false. `UNSET` MUST stay 0: pre-v7 rows read every v7 field as its
 * `FlatBuffer` default, and 0 is also the Go Object-API zero value and the
 * Postgres column default, so 0 has to mean "behave as before v7" — which a
 * `bool` defaulting to false could not express.
 */
export enum ActiveState {
  UNSET = 0,
  ACTIVE = 1,
  INACTIVE = 2,
}
